import { render, staticRenderFns } from "./AssessmentComponent.vue?vue&type=template&id=1c2107e8&scoped=true"
import script from "./AssessmentComponent.vue?vue&type=script&lang=js"
export * from "./AssessmentComponent.vue?vue&type=script&lang=js"
import style0 from "./AssessmentComponent.vue?vue&type=style&index=0&id=1c2107e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2107e8",
  null
  
)

export default component.exports